export default "__VITE_ASSET__DgsT6EFq__"